module.exports = __webpack_public_path__ + "static/media/login-banner.aa37f688.PNG";